import { Typography } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { trakrefBlue } from '../../../color_utils';
import '../../../components/Common/Table/Table.css';

const SystemGrid = ({ systems, materialTypeName }) => {
    const columns = [
        {
            field: 'systemName',
            headerName: 'System',
            flex: 2,
        },
        {
            field: 'startWeightLbs',
            headerName: 'Start Weight (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'startWeightMt',
            headerName: 'Start Weight (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'endWeightLbs',
            headerName: 'End Weight (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'endWeightMt',
            headerName: 'End Weight (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'differenceLbs',
            headerName: 'Difference (lbs)',
            type: 'number',
            valueFormatter: (value) => value?.toLocaleString() || '0',
        },
        {
            field: 'differenceMt',
            headerName: 'Difference (Mt)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
        {
            field: 'gwp',
            headerName: 'GWP',
            type: 'number',
        },
        {
            field: 'potentialEmissions',
            headerName: 'Potential Emissions (MtCO₂e)',
            type: 'number',
            valueFormatter: (value) => value?.toFixed(4) || '0.0000',
        },
    ];

    if (!systems || systems.length === 0) {
        return null;
    }

    return (
        <div className="subtable">
            <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 600, color: trakrefBlue, mb: 1 }}>
                Systems — {materialTypeName}
            </Typography>
            <DataGridPro
                rows={systems}
                columns={columns}
                hideFooter
                disableRowSelectionOnClick
                columnHeaderHeight={45}
                getRowClassName={params => params.indexRelativeToCurrentPage % 2 === 0 ? 'even-row' : 'odd-row'}
                slotProps={{
                    loadingOverlay: {
                        variant: 'linear-progress',
                        noRowsVariant: 'linear-progress',
                    },
                }}
                sx={{
                    '& .MuiDataGrid-cell, & .MuiDataGrid-columnHeader': {
                        flex: 1,
                    },
                }}
            />
        </div>
    );
};

export default SystemGrid;
